// Charts
import { commentsHistoryConfig } from '@/lib/analytics/charts/youtube/commentsHistory';
import { likesHistoryConfig } from '@/lib/analytics/charts/youtube/likesHistory';
import { postHistoryConfig } from '@/lib/analytics/charts/youtube/postHistory';
import { sharesHistoryConfig } from '@/lib/analytics/charts/youtube/sharesHistory';
import { subscribersGrowthConfig } from '@/lib/analytics/charts/youtube/subscribersGrowthHistory';
import { videoViewsHistoryConfig } from '@/lib/analytics/charts/youtube/videoViewsHistory';
// Kpis
import { totalCommentsConfig } from '@/lib/analytics/kpis/youtube/totalComments';
import { totalLikesConfig } from '@/lib/analytics/kpis/youtube/totalLikes';
import { totalPostsConfig } from '@/lib/analytics/kpis/youtube/totalPosts';
import { totalSharesConfig } from '@/lib/analytics/kpis/youtube/totalShares';
import { totalSubscribersConfig } from '@/lib/analytics/kpis/youtube/totalSubscribers';
import { totalViewsConfig } from '@/lib/analytics/kpis/youtube/totalViews';
// Widget
import { mostRecentVideosConfig } from '@/lib/analytics/widget/youtube/mostRecentVideosConfig';
import { SIZE_FULL } from '@/lib/gridElements/size';

export const OverviewYoutube = [
    totalSubscribersConfig,
    totalPostsConfig,
    totalViewsConfig,
    totalLikesConfig,

    subscribersGrowthConfig,
    mostRecentVideosConfig,

    totalCommentsConfig,
    totalSharesConfig,

    videoViewsHistoryConfig,
    likesHistoryConfig,

    commentsHistoryConfig,
    sharesHistoryConfig,

    { ...postHistoryConfig, size: SIZE_FULL }
];

export const requestYoutubeParams = [
    [
        'posts',
        'total_views',
        'likes',
        'subscribers',
        'subscriber_growth',
        'engagement',
        'comments',
        'shares'
    ],
    ['video_views_history', 'likes_history', 'comments_history', 'shares_history', 'post_history']
];
